import { makeStyles } from 'tss-react/mui';
import React from 'react';
import { useTranslation } from 'react-i18next';
import ErrorTemplate, {
  ErrorTemplateCode,
} from 'web-library/stories/template/ErrorTemplate/ErrorTemplate';
import Link from 'web-library/stories/atom/Link/Link';
import Typography from 'web-library/stories/atom/Typography/Typography';
import ErrorPageTitle from '../../components/errors/ErrorPageTitle';

import { typographyTheme } from 'web-library/theme/helper/tssHelper';
const useStyles = makeStyles()((theme) => ({
  subtitle: {
    color: theme.color.text.textSecondary,
    ...typographyTheme(theme, 'h4'),
  },
  link: {
    ...typographyTheme(theme, 'h4'),
  },
}));

const Unauthorized = () => {
  const { classes } = useStyles();
  const { t } = useTranslation();

  return (
    <ErrorTemplate
      errorCode={403 as ErrorTemplateCode}
      title={
        <ErrorPageTitle label={t('components->>UnauthorizedAccess.NoPermissionToAccessThisPage')} />
      }
      subtitle={
        <Typography className={classes.subtitle}>
          {t('components->>UnauthorizedAccess.PleaseReportThis')}{' '}
          <Link
            className={classes.link}
            href="https://www.seab.gov.sg/about-us/contact-us/"
            withUnderline
          >
            {t('components->>UnauthorizedAccess.ContactingUs')}
          </Link>
        </Typography>
      }
    />
  );
};

export default Unauthorized;
